<template>
  <material-card
    :title="title"
    data-testId="material-card-title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md4>
            <MaglinkComponentPasswordNumeric
              v-if="consoleSettings !== undefined"
              :initial-value="consoleSettings.password"
              :label="`${ $t('Numeric password') }`"
              :range-rules="[ 100000, 999999999]"
              data-testId="MaglinkComponentPasswordNumeric"
              @onPasswordChange="onPasswordChange"/>
          </v-flex>
          <v-flex
            xs12
            md4>
            <v-text-field
              v-if="consoleSettings !== undefined"
              v-model.number="consoleSettings.passwordTimeout"
              :rules="rules.required"
              :label="`${ $t('Session timeout ({0})', [ $t('Min').toLowerCase() ]) }`"
              data-testId="text-field-Session-timeout"
              counter
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md4
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk"
              data-testId="btn-Save"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onSave()">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValidationOk: false,
    consoleSettings: undefined,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ]
    }
  }),
  mounted () {
    this.Maglink.GetSettings('ConsoleSettings')
      .then(response => {
        this.consoleSettings = {
          password: response.data.password * 1,
          passwordTimeout: response.data.passwordTimeout
        }
      })
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    onPasswordChange (newPassword) {
      this.consoleSettings.password = newPassword
    },
    onSave (event) {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true

        let newSettings = {
          password: this.consoleSettings.password.toString(),
          passwordTimeout: this.consoleSettings.passwordTimeout
        }

        this.Maglink.SetSettings('ConsoleSettings', newSettings)
          .then(response => {
            // this.snack('success', response.data['done'])

            this.Maglink.ApplySettings()
              .then(response => {
                this.snack('success', this.$t('Console application will restart'))
              })
              .catch(error => (this.snack('error', error.message)))
          })
          .catch(error => (this.snack('error', error.message)))
      } else {
        this.isValidationOk = false
      }
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
